angular.module("ngSentry", []);
Sentry.init({
  dsn: "https://40b397ed6bb844c8906c3cee57e86fb1@o133707.ingest.sentry.io/6169262",
  integrations: [new Sentry.Integrations.Angular()],
  tracesSampleRate: 1.0,
});
